'use client';

import type { ClassValue } from 'clsx';
import type { ProductToCompareT } from '../../../../../type/product/productComparison';

import {
  ProductComparisonLabelCell,
  ProductComparisonLabelCellVariant,
  ProductComparisonRow,
  ProductComparisonRowList,
  ProductComparisonRowVariant,
  ProductComparisonSummaryCell,
  ProductComparisonSummaryCopy,
  ProductComparisonSummaryName,
} from '@vs-shop/commerce-ui/productComparison';

import { clsxm } from '@vs-shop/utils';

import { getDefaultCurrency } from '../../../../../config/currency';

import ProductComparisonAddProductToCartButton from './ProductComparisonAddProductToCartButton';
import { IntlMoney } from '../../../../server/intl/Intl';

type Props = {
  products: readonly ProductToCompareT[];
  className?: ClassValue;
};

export default function ProductComparisonTableSummaryRow({ products, className }: Props) {
  const currency = getDefaultCurrency();

  return (
    <ProductComparisonRow variant={ProductComparisonRowVariant.PLAIN} className={clsxm(className)}>
      {/* LEFT INFO */}
      <ProductComparisonLabelCell variant={ProductComparisonLabelCellVariant.HEADER_OPEN} />

      {/* PRODUCT COLUMNS */}
      <ProductComparisonRowList>
        {products.map((product) => (
          <ProductComparisonSummaryCell key={product.code}>
            <ProductComparisonSummaryCopy>
              <ProductComparisonSummaryName>{product.name}</ProductComparisonSummaryName>
              <span>
                <IntlMoney value={{ amount: product.price, currency }} />
              </span>
            </ProductComparisonSummaryCopy>
            <ProductComparisonAddProductToCartButton product={product} />
          </ProductComparisonSummaryCell>
        ))}
      </ProductComparisonRowList>
    </ProductComparisonRow>
  );
}
